import service from 'utils/request'
const urlObj = {
  cur_node: "/sys/emapflow/tasks/getCurrentNodesByTask.do",
  node: '/sys/emapflow/tasks/getNextNodesByTask.do',
  assignee: '/sys/emapflow/definition/getAssigneesInBpmnByNode.do',
  params: '/sys/emapflow/definition/getRenderFlowComponentParamsInForm.do',
  circulator: '/sys/emapflow/definition/getCirculatedUsersInBpmnByNode.do'
}

const getFlowParams = (params) => {
  return service({
    url: urlObj.params,
    params: params
  })
}

const getCurNode = (params) => {
  return service({
    url: urlObj.cur_node,
    params: params
  })
}


const getNodes = (url, data) => {
  return service({
    url: url || urlObj.node,
    method: 'post',
    data: data
  })
}

const getAssignees = (url, data) => {
  if(url && typeof url === "object") {
    data = url;
  }
  return service({
    url: url || urlObj.assignee,
    method: 'post',
    data: data
  })
}

const getCirculors = (data) => {
  return service({
    url: urlObj.circulator,
    method: 'post',
    data: data
  })
}

const nextstepApi = {
  getFlowParams, getCurNode, getNodes, getAssignees, getCirculors
}

export {
  getFlowParams, getCurNode, getNodes, getAssignees, getCirculors
}
export default nextstepApi